// Turns a city's counted activity categories into a human verb phrase for copy,
// e.g. ["run"] -> "run", ["run","bike"] -> "run and bike",
// ["run","walk","bike"] -> "run, walk and bike".
const ORDER = ["run", "walk", "bike"] as const;

export const ACTIVITY_OPTIONS: { key: string; label: string }[] = [
  { key: "run", label: "Run" },
  { key: "walk", label: "Walk" },
  { key: "bike", label: "Bike" },
];

export function activityVerb(types?: string[] | null): string {
  const picked = ORDER.filter((t) => (types ?? ["run"]).includes(t));
  if (picked.length <= 1) return picked[0] ?? "run";
  return `${picked.slice(0, -1).join(", ")} and ${picked[picked.length - 1]}`;
}

// Toggle a category in/out, kept in canonical order, never emptying the set
// (a city must count at least one activity).
export function toggleActivity(types: string[], key: string): string[] {
  const next = types.includes(key)
    ? types.filter((t) => t !== key)
    : [...types, key];
  return next.length ? ORDER.filter((t) => next.includes(t)) : types;
}
